
import ListSaveButton from "../../Components/ListSaveButton";
import PageTabs from "../../Components/PageTabs";
import React, { useEffect, useState, useRef, useContext, useCallback } from "react";
import TableButton from "../../Props/TableButton";
import ItemMaster from "../../../API/APIServices/ItemMaster";
import PartyWiseItemPriceService from "../../../API/APIServices/PartyWiseItemPriceService";
import AutoSuggestionBox from "../../Components/AutoSuggestionBox";
import MainButton from "../../Props/MainButton";
import MyContext from "../../MyContext";
import AccountAPI from "../../../API/APIServices/Account";
import Loader from "../../Props/Loader";

function ProductPriceAccountWise() {

    /***********title***************/
    useEffect(() => {
        document.title = 'Product Price Account Wise';
    }, []);

    const { debounce } = useContext(MyContext);

    const [loading, setLoading] = useState(false);
    const [showFilterPopUp, setShowFilterPopUp] = useState(false);
    const [itemList, setItemList] = useState([]);
    const [backupItemList, setBackupItemList] = useState([]);
    const input1Ref = useRef(null);
    const input2Ref = useRef(null);
    const [productName, setProductName] = useState("");
    const [productGroup, setProductGroup] = useState("");
    const [selectedProductName, setSelectedProductName] = useState("");
    const [selectedProductGroup, setSelectedProductGroup] = useState("");
    const [partyId, setPartyId] = useState(0);
    const [productNameId, setProductNameId] = useState(0);
    const [productGroupId, setProductGroupId] = useState(0);

    const [partyName, setPartyName] = useState("");
    const [filteredAccount, setFilteredAccount] = useState([]);
    const [filteredProductName, setFilteredProductName] = useState([]);
    const [filteredProductGroup, setFilteredProductGroup] = useState([]);
    const [isDropdownPartyName, setIsDropdownPartyName] = useState(false);
    const [isDropdownProductName, setIsDropdownProductName] = useState(false);
    const [isDropdownProductGroup, setIsDropdownProductGroup] = useState(false);
    const dropDownRef = useRef(null);
    const [edit, setEdit] = useState(false);

    const [page, setPage] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);
    const [pageSize, setPageSize] = useState(100);
    const [selectedItems, setSelectedItems] = useState([]);
    const [partyWiseItemData, setPartyWiseItemData] = useState([]);


    async function fetchData() {

        setLoading(true);

        const filter = {
            "filter": [
                {
                    "fieldName": "string",
                    "operatorName": "string",
                    "compareValue": "string"
                }
            ],
            "order": [
                {
                    "propertyName": "string",
                    "ascending": true
                }
            ],
            "attribute": [
                {
                    "parentId": 0,
                    "attrId": 0
                }
            ],
            "ecomAttributeFilter": true,
            "pageNumber": page,
            "pageSize": pageSize,
            "itemGroupId2": 0,
            "isEcom": true
        };

        let item_list = await ItemMaster.GetItemMasterWithPagination(filter);

        if (item_list?.isSuccess) {

            setTotalRecords(item_list.totalRecords);
            item_list = item_list.result.map(item => {

                item.isSelected = false
                item.salePrice = 0;
                item.purchasePrice = 0;
                item.mrp = 0;

                return item;
            });

        } else {
            item_list = [];
        }


        setItemList(item_list);
        setBackupItemList(item_list);

        setLoading(false);
    }

    useEffect(() => {
        fetchData();
    }, []);


    function showShowFilterPopUp() {
        setShowFilterPopUp(true);
    }

    function hideShowFilterPopUp() {
        setShowFilterPopUp(false);
    }

    const handleSelectAll = (e) => {


        setCopyBtnRC({ R: -1, C: -1 });
        if (partyId == 0) {
            alert("First select party");
            return;
        }

        let boolVal = e.target.checked;

        let tempItemList = itemList.map(item => {

            return {
                ...item,
                isSelected: boolVal
            };
        });

        let tempSelectedItems = [...selectedItems];

        if (boolVal) {

            for (let i = 0; i < tempItemList.length; i++) {

                const fIndex = tempSelectedItems.findIndex(item => item.d2Id == tempItemList[i].d2Id);

                if (fIndex == -1) {
                    tempSelectedItems.push(tempItemList[i]);
                }
            }

        } else {

            let tempPartyWiseItemData = [...partyWiseItemData];

            tempSelectedItems = selectedItems.filter(item => {

                tempPartyWiseItemData = tempPartyWiseItemData.filter(partyItem => partyItem.itemId !== item.d2Id);

                const findItem = tempItemList.find(e => e.d2Id == item.d2Id);

                if (findItem === undefined) {
                    return true;
                } else {
                    return false;
                }
            });

            setPartyWiseItemData(tempPartyWiseItemData);

        }

        setSelectedItems(tempSelectedItems);

        setIsAllSelected(boolVal);
        setItemList(tempItemList);
    };

    // useEffect(()=>{

    //     const tempItemList = [...itemList];
    //     let temPartyWiseItemData = [...partyWiseItemData];
    //     let tempSelectedItems = [...selectedItems];

    //     for(let i=0; i<tempItemList.length; i++){

    //         const d2Id = tempItemList[i].d2Id;

    //         let fIndex = temPartyWiseItemData.findIndex(item => item.itemId == d2Id);

    //         if(fIndex !== -1){
    //             tempItemList[i].salePrice = temPartyWiseItemData[fIndex].salePrice;
    //             tempItemList[i].purchasePrice = temPartyWiseItemData[fIndex].purchasePrice;
    //             tempItemList[i].mrp = temPartyWiseItemData[fIndex].mrp;

    //             tempSelectedItems = tempSelectedItems.filter(item => item.d2Id != d2Id);
    //             tempSelectedItems.push(tempItemList[i]);

    //             temPartyWiseItemData = temPartyWiseItemData.filter(item => item.itemId != d2Id);
    //         }
    //     }

    //     setSelectedItems(tempSelectedItems);
    //     setPartyWiseItemData(temPartyWiseItemData);
    //     setItemList(tempItemList);

    // },[itemList, partyWiseItemData]);

    useEffect(() => {

        console.log("selectedItems", selectedItems)
    }, [selectedItems]);

    const [copyBtnRC, setCopyBtnRC] = useState({ R: -1, C: -1 });

    const [isAllSelected, setIsAllSelected] = useState(false);

    function handleRightClick(e, rIndex, cIndex) {


        e.preventDefault();
        console.log(copyBtnRC)
        console.log({ rIndex, cIndex })

        if (copyBtnRC.R == rIndex && copyBtnRC.C == cIndex) {
            setCopyBtnRC({ R: -1, C: -1 });
        } else {
            setCopyBtnRC({ R: rIndex, C: cIndex });
        }
    }

    const handleChangeData = (index, key, value) => {

        setCopyBtnRC({ R: -1, C: -1 });
        if (partyId == 0) {
            alert("First select party");
            return;
        }

        console.log({ index, key, value })

        let tempItemList = [...itemList];

        tempItemList[index][key] = value;

        const d2Id = tempItemList[index].d2Id;

        if (key == "isSelected") {

            let findFalse = tempItemList.find(item => item.isSelected == false);

            if (findFalse === undefined) {
                setIsAllSelected(true);
            } else {
                setIsAllSelected(false);
            }

            let tempSelectedItems = [...selectedItems];

            if (value === true) {

                const obj = {
                    ...tempItemList[index],
                    isSelected: undefined
                };

                const fIndex = tempSelectedItems.findIndex(item => item.d2Id == d2Id);

                if (fIndex == -1) {
                    tempSelectedItems.push(obj);
                } else {
                    tempSelectedItems[fIndex] = obj;
                }

            } else {

                tempSelectedItems = selectedItems.filter(item => item.d2Id != d2Id);

                const tempPartyWiseItemData = partyWiseItemData.filter(item => item.itemId !== d2Id);
                setPartyWiseItemData(tempPartyWiseItemData);
            }

            setSelectedItems(tempSelectedItems);

        } else {

            const tempSelectedItems = [...selectedItems];

            const fIndex = tempSelectedItems.findIndex(item => item.d2Id == d2Id);

            if (fIndex !== -1) {
                tempSelectedItems[fIndex][key] = value;
                setSelectedItems(tempSelectedItems);
            }
        }


        setItemList(tempItemList);
    }

    function handleCopyBtnClick(rIndex, key) {

        let tempItemList = [...itemList];
        let tempSelectedItems = [...selectedItems];

        for (let i = rIndex + 1; i < tempItemList.length; i++) {

            const d2Id = tempItemList[i].d2Id;
            tempItemList[i][key] = tempItemList[rIndex][key];

            if (tempItemList[i].isSelected) {

                const fIndex = tempSelectedItems.findIndex(item => item.d2Id == d2Id);

                if (fIndex !== -1) {
                    tempSelectedItems[fIndex][key] = tempItemList[rIndex][key];
                }
            }
        }

        setSelectedItems(tempSelectedItems);
        setItemList(tempItemList);
        setCopyBtnRC({ R: -1, C: -1 });
    }

    const handleAccountSelection = async (id, name) => {

        console.log(id, name)
        setPartyId(id);
        setPartyName(name);
        setIsDropdownPartyName(false);
    };

    const handleProductNameSelection = async (id, name) => {

        console.log(id, name)
        setProductName(name);
        setProductNameId(id);
        setSelectedProductName(name);
        setIsDropdownProductName(false);
    };

    const handleProductGroupSelection = async (id, name) => {

        console.log(id, name)
        setProductGroup(name);
        setProductGroupId(id);
        setSelectedProductGroup(name);
        setIsDropdownProductGroup(false);
    };

    const handleProductGroupChange = (e) => {

        setProductGroup(e.target.value);
        setSelectedProductGroup("");
        setProductGroupId(0);
        debouncedFetchProductGroupSuggestions("ProductGroup", e.target.value, '');
    }

    const handlePartyNameChange = (e) => {

        setPartyName(e.target.value)
        setPartyId(0);
        debouncedFetchAccountSuggestions("PartyName", e.target.value, '');
    }

    const handleProductNameChange = (e) => {

        setProductName(e.target.value);
        setSelectedProductName("");
        setProductNameId(0);
        debouncedFetchProductNameSuggestions("ProductName", e.target.value, '');
    }


    const fetchSuggestions = async (name, value, GroupId, MasterType) => {

        const filteredData = {
            MasterType: MasterType,
            GroupWiseSuggestion: true,
            GroupId: GroupId,
            search_str: value,
            PageNumber: 1,
            PageSize: 50,
        };

        try {
            const SearchItem = await AccountAPI.GetAccountListForAutoSuggestion(
                filteredData
            );
            return SearchItem;
        } catch (error) {
            console.error("Error fetching account suggestions:", error);
            return [];
        }
    };

    const debouncedFetchAccountSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 2);

            setFilteredAccount(SearchItem);
            setIsDropdownPartyName(true);

        }, 500),
        []
    );

    const debouncedFetchProductNameSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 4);

            setFilteredProductName(SearchItem);
            setIsDropdownProductName(true);

        }, 500),
        []
    );

    const debouncedFetchProductGroupSuggestions = useCallback(
        debounce(async (name, value, GroupId) => {
            const SearchItem = await fetchSuggestions(name, value, GroupId, 3);

            setFilteredProductGroup(SearchItem);
            setIsDropdownProductGroup(true);

        }, 500),
        []
    );

    useEffect(() => {

        function handleClickOutside(event) {

            if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
                setIsDropdownPartyName(false);
                setIsDropdownProductGroup(false);
                setIsDropdownProductName(false);
            }
        }



        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };

    }, []);

    async function handlePartyIDChange(party_id, item_list) {

        setSelectedItems([]);
        let tempItemList = [...item_list];

        if (party_id == 0) {

            tempItemList = tempItemList.map(item => {

                item.isSelected = false;
                item.salePrice = 0;
                item.purchasePrice = 0;
                item.mrp = 0;

                return item;
            })

            setEdit(false);
        } else {

            const filter = {
                "filter": [
                    {
                        "fieldName": "partyId",
                        "operatorName": "equal",
                        "compareValue": party_id
                    }
                ],
                "order": [
                    {
                        "propertyName": "string",
                        "ascending": true
                    }
                ],
                "pageNumber": 0,
                "pageSize": 0
            }

            try {
                const party_wise_data = await PartyWiseItemPriceService.GetAllPartyWiseItemPrice(filter);

                let data = [];
                if (party_wise_data.data.isSuccess) {
                    data = party_wise_data.data.result;

                    if (data.length > 0) {
                        setEdit(true);
                    } else {
                        setEdit(false);
                    }
                } else {
                    setEdit(false);
                }

                const tempSelectedItems = [...selectedItems];

                for (let i = 0; i < tempItemList.length; i++) {

                    const d2Id = tempItemList[i].d2Id;

                    const findData = data.find(item => item.itemId == d2Id);

                    if (findData !== undefined) {
                        tempItemList[i].isSelected = true;
                        tempItemList[i].salePrice = findData.salePrice;
                        tempItemList[i].purchasePrice = findData.purchasePrice;
                        tempItemList[i].mrp = findData.mrp;

                        const fIndex = tempSelectedItems.findIndex(item => item.d2Id == findData.itemId);

                        if (fIndex === -1) {
                            tempSelectedItems.push(tempItemList[i]);
                        }

                        data = data.filter(item => item.itemId != d2Id);

                        setSelectedItems(tempSelectedItems);
                    } else {
                        tempItemList[i].isSelected = false;
                        tempItemList[i].salePrice = 0;
                        tempItemList[i].purchasePrice = 0;
                        tempItemList[i].mrp = 0;
                    }
                }

                setPartyWiseItemData(data);

            } catch (e) {

                alert("Error when fetching party wise account data!")
                console.log("Error when fetching party wise account data!", e);
            }
        }

        setItemList(tempItemList);
    };

    async function fetchFilterItemList(product_name_id, product_group_id, page_num) {


        let filterToSend = [];

        if (product_name_id) {

            filterToSend.push({
                "fieldName": "d2Id",
                "operatorName": "equal",
                "compareValue": product_name_id
            });

        }

        if (product_group_id) {

            filterToSend.push({
                "fieldName": "parentGrpId2",
                "operatorName": "equal",
                "compareValue": product_group_id
            });

        }

        const filter = {
            "filter": filterToSend,
            "order": [
                {
                    "propertyName": "string",
                    "ascending": true
                }
            ],
            "attribute": [
                {
                    "parentId": 0,
                    "attrId": 0
                }
            ],
            "ecomAttributeFilter": true,
            "pageNumber": page_num,
            "pageSize": pageSize,
            "itemGroupId2": 0,
            "isEcom": true
        };

        setLoading(true);
        let item_list = await ItemMaster.GetItemMasterWithPagination(filter);

        if (item_list?.isSuccess) {

            setTotalRecords(item_list.totalRecords);

            item_list = item_list.result.map(item => {

                item.isSelected = false
                item.salePrice = 0;
                item.purchasePrice = 0;
                item.mrp = 0;

                return item;
            });
        } else {
            item_list = [];
        }


        let tempItemList = item_list;

        if (partyId == 0) {

            for (let i = 0; i < tempItemList.length; i++) {

                const d2Id = tempItemList[i].d2Id;

                const findItem = selectedItems.find(item => item.d2Id == d2Id);

                if (findItem === undefined) {

                    tempItemList[i].isSelected = false;
                    tempItemList[i].salePrice = 0;
                    tempItemList[i].purchasePrice = 0;
                    tempItemList[i].mrp = 0;
                } else {

                    tempItemList[i].isSelected = true;
                    tempItemList[i].salePrice = findItem.salePrice;
                    tempItemList[i].purchasePrice = findItem.purchasePrice;
                    tempItemList[i].mrp = findItem.mrp;
                }
            }

            setEdit(false);
        } else {


            const tempSelectedItems = [...selectedItems];
            let tempPartyWiseItemData = [...partyWiseItemData];

            for (let i = 0; i < tempItemList.length; i++) {

                const d2Id = tempItemList[i].d2Id;

                const findDataInSelected = tempSelectedItems.find(item => item.d2Id == d2Id);

                if (findDataInSelected !== undefined) {

                    tempItemList[i].isSelected = true;
                    tempItemList[i].salePrice = findDataInSelected.salePrice;
                    tempItemList[i].purchasePrice = findDataInSelected.purchasePrice;
                    tempItemList[i].mrp = findDataInSelected.mrp;
                } else {

                    const findData = tempPartyWiseItemData.find(item => item.itemId == d2Id);

                    if (findData !== undefined) {
                        tempItemList[i].isSelected = true;
                        tempItemList[i].salePrice = findData.salePrice;
                        tempItemList[i].purchasePrice = findData.purchasePrice;
                        tempItemList[i].mrp = findData.mrp;

                        const fIndex = tempSelectedItems.findIndex(item => item.d2Id == findData.itemId);

                        if (fIndex === -1) {
                            tempSelectedItems.push(tempItemList[i]);
                        }

                        tempPartyWiseItemData = tempPartyWiseItemData.filter(item => item.itemId != d2Id);

                    } else {
                        tempItemList[i].isSelected = false;
                        tempItemList[i].salePrice = 0;
                        tempItemList[i].purchasePrice = 0;
                        tempItemList[i].mrp = 0;
                    }

                }

            }

            setSelectedItems(tempSelectedItems);
            setPartyWiseItemData(tempPartyWiseItemData);

        }

        setItemList(tempItemList);
        setLoading(false);
    }


    useEffect(() => {

        fetchFilterItemList(productNameId, productGroupId, page);

    }, [productNameId, productGroupId, page]);


    useEffect(() => {

        handlePartyIDChange(partyId, itemList);
    }, [partyId]);

    const Save = async () => {

        console.log("itemList");
        console.log(itemList);

        if (!partyId) {

            alert("Please Select Party Id");
            return;
        }

        if (edit === false) {

            // let dataToSEnd = itemList.filter(item => item.isSelected).map(item => {

            //     return {

            //         partyId: partyId,
            //         itemId: item.d2Id,
            //         salePrice: Number(item.salePrice),
            //         purchasePrice: Number(item.purchasePrice),
            //         mrp: Number(item.mrp),
            //         saleDiscount: 0,
            //         purchaseDiscount: 0
            //     };
            // });


            let dataToSEnd = selectedItems.map(item => {

                return {

                    partyId: partyId,
                    itemId: item.d2Id,
                    salePrice: Number(item.salePrice),
                    purchasePrice: Number(item.purchasePrice),
                    mrp: Number(item.mrp),
                    saleDiscount: 0,
                    purchaseDiscount: 0
                };
            });

            setLoading(true);
            try {

                const response = await PartyWiseItemPriceService.CreatePartyWiseItemPrice(dataToSEnd);

                if (response.data.isSuccess) {
                    setEdit(true);
                    handlePartyIDChange(partyId, itemList);
                    alert("Product Price Account/Party Wise Created Successfully!")
                } else {
                    console.log("Failed To Create Product Price Account/Party Wise!", response.data.errorMessages);
                    alert("Failed To Create Product Price Account/Party Wise!")
                }

            } catch (e) {
                console.log("Failed To Create Product Price Account/Party Wise!", e);
                alert("Failed To Create Product Price Account/Party Wise!")
            }

        } else {

            // let dataToSEnd = itemList.filter(item => item.isSelected).map(item => {

            //     return {

            //         partyId: partyId,
            //         itemId: item.d2Id,
            //         salePrice: Number(item.salePrice),
            //         purchasePrice: Number(item.purchasePrice),
            //         mrp: Number(item.mrp),
            //         saleDiscount: 0,
            //         purchaseDiscount: 0
            //     };
            // });

            let dataToSEnd = selectedItems.map(item => {

                return {

                    partyId: partyId,
                    itemId: item.d2Id,
                    salePrice: Number(item.salePrice),
                    purchasePrice: Number(item.purchasePrice),
                    mrp: Number(item.mrp),
                    saleDiscount: 0,
                    purchaseDiscount: 0
                };
            });

            setLoading(true);
            try {

                const response = await PartyWiseItemPriceService.UpdatePartyWiseItemPrice(dataToSEnd, partyId);

                if (response.data.isSuccess) {
                    handlePartyIDChange(partyId, itemList);
                    alert("Product Price Account/Party Wise Updated Successfully!")
                } else {
                    console.log("Failed To Update Product Price Account/Party Wise!", response.data.errorMessages);
                    alert("Failed To Update Product Price Account/Party Wise!")
                }

            } catch (e) {
                console.log("Failed To Update Product Price Account/Party Wise!", e);
                alert("Failed To Update Product Price Account/Party Wise!")
            }

        }


        setLoading(false);
    }

    async function deleteProductPriceOfAccount() {

        try {

            let response = await PartyWiseItemPriceService.DeletePartyWiseItemPrice(partyId);

            if (response.data.isSuccess) {

                handlePartyIDChange(partyId, itemList);
                setEdit(false);
                alert("Product Price Account/Party Wise Deleted Successfully!");
            } else {
                console.log("Failed To Update Product Price Account/Party Wise!", response.data.errorMessages);
                alert("Failed To Update Product Price Account/Party Wise!");
            }

        } catch (e) {

            console.log("Failed To Update Product Price Account/Party Wise!", e);
            alert("Failed To Update Product Price Account/Party Wise!");
        }
    }

    useEffect(() => {


        let findFalse = itemList.find(item => item.isSelected == false);

        if (findFalse === undefined) {
            setIsAllSelected(true);
        } else {
            setIsAllSelected(false);
        }

    }, [itemList]);


    function handlePrevClick() {

        setCopyBtnRC({ R: -1, C: -1 });

        if (page == 1) return;

        setPage(page - 1);
    }

    function handleNextClick() {

        setCopyBtnRC({ R: -1, C: -1 });

        if (page == Math.ceil(totalRecords / pageSize)) return;

        setPage(page + 1);
    }


    //************End Check box************/ /
    return (
        <div className="" >
            < PageTabs />
            <div className="nav-1" >
                <div className="panel-heading">
                    <h2 className="panel-title">Product Price Account Wise</h2>

                    <MainButton SaveButton={Save} />

                </div>
                <div className="panel panel-default">
                    <div className="panel-body">
                        <div className="search_panel_hd1">
                            <div style={{ width: "60%" }}>
                                <div ref={dropDownRef} className="col-sm-n1" style={{ width: "100%", alignItems: "center", justifyContent: "center" }}>

                                    <div className="group_head" style={{ position: "relative" }}>
                                        {/* <svg className="search_panel_icon" aria-hidden="true" viewBox="0 0 24 24"><g><path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path></g></svg> */}
                                        <input style={{ width: "90%" }} value={productName} onChange={handleProductNameChange} onClick={() => {

                                            setIsDropdownProductGroup(false);
                                            setIsDropdownPartyName(false);
                                            debouncedFetchProductNameSuggestions("ProductName", productName, '')
                                        }
                                        } placeholder="Product Name" type="text" className="bill_panel_input" />


                                        {isDropdownProductName && (
                                            <ul
                                                style={{ position: "absolute", top: "35px" }}
                                                className="ItemmasterDuggestionsaleinvoice"
                                            // ref={suggestionBoxRef}
                                            >
                                                {filteredProductName.map((pName, index) => (
                                                    <li
                                                        key={index}
                                                        // ref={(el) =>
                                                        //     (itemRefs.current[index] = el)
                                                        // }
                                                        onClick={() =>
                                                            handleProductNameSelection(
                                                                pName.id,
                                                                pName.name
                                                            )
                                                        }
                                                    >
                                                        {pName.name}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                    </div>

                                    <div className="group_head">
                                        {/* <svg className="search_panel_icon" aria-hidden="true" viewBox="0 0 24 24"><g><path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path></g></svg> */}
                                        <input style={{ width: "90%" }} value={productGroup} onChange={handleProductGroupChange} onClick={() => {

                                            setIsDropdownPartyName(false);
                                            setIsDropdownProductName(false);
                                            debouncedFetchProductGroupSuggestions("ProductGroup", productGroup, '')

                                        }} placeholder="Product Group" type="text" className="bill_panel_input" />

                                        {isDropdownProductGroup && (
                                            <ul
                                                style={{ position: "absolute", top: "35px" }}
                                                className="ItemmasterDuggestionsaleinvoice"
                                            // ref={suggestionBoxRef}
                                            >
                                                {filteredProductGroup.map((pGroup, index) => (
                                                    <li
                                                        key={index}
                                                        // ref={(el) =>
                                                        //     (itemRefs.current[index] = el)
                                                        // }
                                                        onClick={() =>
                                                            handleProductGroupSelection(
                                                                pGroup.id,
                                                                pGroup.name
                                                            )
                                                        }

                                                    >
                                                        {pGroup.name}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}
                                    </div>

                                    <div className="group_head" style={{ position: "relative" }}>
                                        {/* <svg className="search_panel_icon" aria-hidden="true" viewBox="0 0 24 24"><g><path d="M21.53 20.47l-3.66-3.66C19.195 15.24 20 13.214 20 11c0-4.97-4.03-9-9-9s-9 4.03-9 9 4.03 9 9 9c2.215 0 4.24-.804 5.808-2.13l3.66 3.66c.147.146.34.22.53.22s.385-.073.53-.22c.295-.293.295-.767.002-1.06zM3.5 11c0-4.135 3.365-7.5 7.5-7.5s7.5 3.365 7.5 7.5-3.365 7.5-7.5 7.5-7.5-3.365-7.5-7.5z"></path></g></svg> */}
                                        <input style={{ width: "90%" }} onChange={handlePartyNameChange} onClick={() => {

                                            setIsDropdownProductGroup(false);
                                            setIsDropdownProductName(false);
                                            debouncedFetchAccountSuggestions("PartyName", partyName, '')
                                        }} value={partyName} placeholder="Party Name" type="text" className="bill_panel_input" />


                                        {isDropdownPartyName && (
                                            <ul
                                                style={{ position: "absolute", top: "35px" }}
                                                className="ItemmasterDuggestionsaleinvoice"
                                            // ref={suggestionBoxRef}
                                            >
                                                {filteredAccount.map((Acc, index) => (
                                                    <li
                                                        key={index}
                                                        // ref={(el) =>
                                                        //     (itemRefs.current[index] = el)
                                                        // }
                                                        onClick={() =>
                                                            handleAccountSelection(
                                                                Acc.d1RefId,
                                                                Acc.name
                                                            )
                                                        }
                                                    >
                                                        {Acc.name}{" "}
                                                        {Acc.mobileNo
                                                            ? `(${Acc.mobileNo})`
                                                            : ""}
                                                    </li>
                                                ))}
                                            </ul>
                                        )}

                                    </div>


                                    {/* <div onClick={showShowFilterPopUp} style={{ width: "70px" }} className="product-price-account-wise-filter-button">

                                        <i class="fa-solid fa-filter"></i>
                                    </div> */}


                                    {edit && <button onClick={deleteProductPriceOfAccount} className="product-price-account-wise-delete-button">Delete</button>}

                                </div>
                            </div>


                        </div>


                        <div className="col-sm-12">
                            <div className="table-resposive" >
                                <table id="tblTransactionList" className="table_hd1 table-bordered1 fixedheightTable" frame="box" style={{maxHeight:"76vh"}}>
                                    <thead textAlign="center" className="thead_scroll_col1 " style={{ position: "sticky", top: "0px", backgroundColor: "#212e4f", color: "white", zIndex: "1", height:"35px" }}>
                                        <tr className="">
                                            {/* <th><div className="table_head_m1">S.No.</div></th> */}


                                            <th className="td_col6" style={{ width: "50px" }}> <div>
                                                <div><input type="checkbox" className="check_box" checked={isAllSelected}
                                                    onChange={handleSelectAll} name="" id="" /></div>
                                            </div> </th>

                                            <th className="td_col6" style={{ width: "50px" }}> <div>
                                                <div className="table_head_mmb1">S.No.</div>
                                                {/* <div className="table_head_mmb2"><i className="fa-solid fa-sort-up t_icon1"></i><i className="fa-solid fa-sort-down t_icon2"></i></div> */}
                                            </div> </th>


                                            <th className="td_col6" style={{ width: "30%" }}> <div style={{ margin: "auto" }} className="table_head_nnb" >
                                                <div className="table_head_mmb1" style={{ textAlign: "center", width: "auto" }}>Item Name</div>
                                            </div> </th>
                                            <th className="td_col6" style={{ width: "30%" }}> <div style={{ margin: "auto" }} className="table_head_nnb">
                                                <div className="table_head_nnb1" style={{ textAlign: "center", width: "auto" }}>Parent Group</div>
                                            </div> </th>
                                            <th className="td_col6"> <div className="table_head_nhb" >
                                                <div className="table_head_mmb1" style={{ textAlign: "center", width: "auto" }}>Sale Price</div>
                                            </div> </th>
                                            <th className="td_col6" > <div className="table_head_nhb" >
                                                <div className="table_head_mmb1" style={{ textAlign: "center", width: "auto" }}>Purchase Price</div>
                                            </div> </th>
                                            <th className="td_col6" > <div className="table_head_nhb" >
                                                <div className="table_head_mmb1" style={{ textAlign: "center", width: "auto" }}>MRP Price</div>
                                            </div> </th>




                                            {/* <th className="table_edit table_head_mmb1 " style={{ textAlign: "center" }} >Open</th> */}
                                            {/* <th className="table_delete table_head_mmb1" style={{ textAlign: "center" }} >Delete</th> */}


                                        </tr>
                                    </thead>
                                    <tbody className="tbody_body_m1">

                                        {itemList.map((item, index) => {

                                            //                                             let tempProductName = productName ? productName : "";
                                            // tempProductName = tempProductName.toLowerCase().trim();

                                            // let tempProductGroup = productGroup ? productGroup : "";
                                            // tempProductGroup = tempProductGroup.toLowerCase().trim();
                                            //                                     if()
                                            return (
                                                <tr key={index} className="table_tbody_tr1">
                                                    <td className="td_col6" style={{ textAlign: "center" }}><input type="checkbox" className="check_box" checked={item.isSelected}
                                                        onChange={(e) => handleChangeData(index, "isSelected", e.target.checked)} name="" id="" /></td>

                                                    <td className="td_col6">{(pageSize * (page - 1)) + index + 1}</td>

                                                    <td className="td_col6" style={{ textAlign: "center" }}>{item.name}</td>
                                                    <td className="td_col6" style={{ textAlign: "center" }}>{item.parentGrpName ? item.parentGrpName : ""}</td>
                                                    <td onContextMenu={(e) => handleRightClick(e, index, 0)} className="td_col6" style={{ textalign: "start", position: "relative" }}>
                                                        <input className="table-input-box2" type="number" min="0" name="salePrice" id="" value={item["salePrice"]} onChange={(e) => handleChangeData(index, e.target.name, e.target.value)} />
                                                        {(copyBtnRC.R == index && copyBtnRC.C == 0) && (
                                                            <button onClick={() => handleCopyBtnClick(index, "salePrice")} title="Copy to all rows" className="product-price-account-wise-copy-button">
                                                                <i class="fa-solid fa-copy"></i>
                                                            </button>
                                                        )}

                                                    </td>
                                                    <td onContextMenu={(e) => handleRightClick(e, index, 1)} className="td_col6" style={{ textalign: "start", position: "relative" }}>
                                                        <input className="table-input-box2" type="number" min="0" name="purchasePrice" id="" value={item["purchasePrice"]} onChange={(e) => handleChangeData(index, e.target.name, e.target.value)} />
                                                        {(copyBtnRC.R == index && copyBtnRC.C == 1) && (
                                                            <button onClick={() => handleCopyBtnClick(index, "purchasePrice")} title="Copy to all rows" className="product-price-account-wise-copy-button">
                                                                <i class="fa-solid fa-copy"></i>
                                                            </button>
                                                        )}</td>
                                                    <td onContextMenu={(e) => handleRightClick(e, index, 2)} className="td_col6" style={{ textalign: "start", position: "relative" }}>
                                                        <input className="table-input-box2" type="number" min="0" name="mrp" id="" value={item["mrp"]} onChange={(e) => handleChangeData(index, e.target.name, e.target.value)} />
                                                        {(copyBtnRC.R == index && copyBtnRC.C == 2) && (
                                                            <button onClick={() => handleCopyBtnClick(index, "mrp")} title="Copy to all rows" className="product-price-account-wise-copy-button">
                                                                <i class="fa-solid fa-copy"></i>
                                                            </button>
                                                        )}</td>


                                                    {/* <td><button className="edit_btn"><i className="fa-solid fa-pen-to-square"></i></button></td> */}
                                                    {/* <td><button className="delete_btn"><i className="fa-solid fa-trash"></i></button></td> */}


                                                </tr>

                                            )
                                        })}

                                    </tbody>
                                </table>
                            </div>
                        </div>

                        <div className="table-list-button-box" style={{padding:"10px 20px"}}>

                            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", width: "200px", margin: "5px 0px;" }}>
                                <button onClick={handlePrevClick} class="table-list-button">
                                    <i class="fa-solid fa-chevron-left"></i>
                                </button>
                                <span class="table-list-page-txt">Page -<strong style={{ margin: "0px 3px;" }}>{page} of {Math.ceil(totalRecords / pageSize)}</strong></span>
                                <button onClick={handleNextClick} class="table-list-button">
                                    <i class="fa-solid fa-chevron-right"></i>
                                </button>
                            </div>



                        </div>
                    </div>
                </div>
            </div>

            {showFilterPopUp && (
                <div className="product-price-account-wise-filter-popup">

                    <div className="product-price-account-wise-filter-label">Filter</div>

                    <div className="product-price-account-wise-filter-grid-div">

                        <div className="input-box-m11">
                            <input className="modify_im_input mode_limit mode_category" type="text" required />
                            <label class="modifyTextLabel">From SPH</label>
                        </div>
                        <div className="input-box-m11">
                            <input className="modify_im_input mode_limit mode_category" type="text" required />
                            <label class="modifyTextLabel">To SPH</label>
                        </div>

                        <div className="input-box-m11">
                            <input className="modify_im_input mode_limit mode_category" type="text" required />
                            <label class="modifyTextLabel">From CYL</label>
                        </div>
                        <div className="input-box-m11">
                            <input className="modify_im_input mode_limit mode_category" type="text" required />
                            <label class="modifyTextLabel">To CYL</label>
                        </div>

                        <div className="input-box-m11">
                            <input className="modify_im_input mode_limit mode_category" type="text" required />
                            <label class="modifyTextLabel">From Add</label>
                        </div>
                        <div className="input-box-m11">
                            <input className="modify_im_input mode_limit mode_category" type="text" required />
                            <label class="modifyTextLabel">To Add</label>
                        </div>

                        <div className="input-box-m11">
                            <input className="modify_im_input mode_limit mode_category" type="text" required />
                            <label class="modifyTextLabel">Axis</label>
                        </div>
                        <div className="input-box-m11">
                            <input className="modify_im_input mode_limit mode_category" type="text" required />
                            <label class="modifyTextLabel">Eye(R/L)</label>
                        </div>

                    </div>

                    <button className="search-button-loyalty">Search</button>


                    <span onClick={hideShowFilterPopUp} className="closeButton" style={{ top: "0px" }}>x</span>
                </div>
            )}

            {loading && <Loader />}

        </div >



    );
}

export default ProductPriceAccountWise;
